// Load all CSS files in the src directory, except ones already pulled in
// via @import by styles.css (bundling them again here would ship the
// same rules twice).
import.meta.glob('../css/vendor/*.css', {
    eager: true,
})
import.meta.glob(
    ['../css/*.css', '!../css/tier-colors.css', '!../css/allauth.css'],
    {
        eager: true,
    }
)

// Load all JavaScript files in the current directory
import.meta.glob('./vendor/*.js', {
    eager: true,
})
import.meta.glob('./*.js', {
    eager: true,
})

import 'htmx.org'

import { library, dom } from '@fortawesome/fontawesome-svg-core'
import {
    faX,
    faArrowLeft,
    faArrowRight,
    faArrowDown,
    faCalendarDays,
    faStar,
    faBars,
    faXmark,
    faCircleQuestion,
    faChevronDown,
    faShareNodes,
    faTrophy,
    faToggleOn,
    faToggleOff,
    faEye,
    faEyeSlash,
    faFire,
    faDownload,
    faArrowUpFromBracket,
    faLocationCrosshairs,
    faScrewdriverWrench,
} from '@fortawesome/free-solid-svg-icons'

library.add(
    faX,
    faArrowLeft,
    faArrowRight,
    faArrowDown,
    faCalendarDays,
    faStar,
    faBars,
    faXmark,
    faCircleQuestion,
    faChevronDown,
    faShareNodes,
    faTrophy,
    faToggleOn,
    faToggleOff,
    faEye,
    faEyeSlash,
    faFire,
    faDownload,
    faArrowUpFromBracket,
    faLocationCrosshairs,
    faScrewdriverWrench
)
dom.watch()
